module.exports = __webpack_public_path__ + "media/images/markers/youtube-f362f86fa1715ace38fe88e6b52a302d.png";